import endsWith from 'lodash/endsWith';

export const getFilePreview = (file: File): string | null =>
  endsWith(file.name, 'pdf') ? null : URL.createObjectURL(file);
